import parse from 'date-fns/parse';
import differenceInYears from 'date-fns/differenceInYears';
import { ADULTHOOD_AGE } from 'products/nomad_insurance/constants';

export const checkIfUserIsAdult = (dateOfBirth, dateOfAdulthoodCheck = new Date()) => {
  const parsedDOBDate =
    dateOfBirth instanceof Date
      ? dateOfBirth
      : parse(dateOfBirth, 'yyyy-MM-dd', new Date());

  const parsedDateOfAdulthoodCheck =
    dateOfAdulthoodCheck instanceof Date
      ? dateOfAdulthoodCheck
      : new Date(dateOfAdulthoodCheck);

  return differenceInYears(parsedDateOfAdulthoodCheck, parsedDOBDate) >= ADULTHOOD_AGE;
};
